import React from 'react';
const SvgIfcThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="#236BB3" d="M69 3l20 20H69z" />
        <path fill="#064C94" d="M11 3v94h78V23H69V3z" />
        <path fill="#FFF" d="M15 7h54v15h16v50H15z" />
        <path fill="#222" opacity={0.1} d="M69 23h20v20z" />
        <path
          d="M47.001 44.455l3.182-3.182 3.182 3.182c1.697 1.697 1.697 4.667 0 6.364l-6.364-6.364z"
          fill="#B62993"
          fillRule="nonzero"
        />
        <path
          d="M46.577 44.03l-.424.425.424.424 6.364 6.364.424.424.425-.424c2.121-2.121 1.909-5.303 0-7.212l-3.182-3.182-.425-.425-.424.425-3.182 3.182z"
          stroke="#FFF"
        />
        <path
          d="M46.153 37.242l3.182 3.182-3.182 3.182c-1.697 1.697-4.667 1.697-6.364 0l6.364-6.364z"
          fill="#005DA4"
          fillRule="nonzero"
        />
        <path
          d="M46.577 36.818l-.424-.424-.424.424-6.364 6.364-.425.424.425.425c2.121 2.12 5.303 1.909 7.212 0l3.182-3.182.424-.425L49.76 40l-3.182-3.182z"
          stroke="#FFF"
        />
        <g>
          <path
            d="M45.092 36.182c-1.697-1.697-4.667-1.697-6.364 0l-7.424 7.424c-1.697 1.697-1.697 4.667 0 6.364l8.273 8.273c1.697 1.697 4.667 1.697 6.364 0l2.121-2.121-3.182-3.182-2.121 2.121-8.485-8.485 4.879-4.879c.212.212 5.94-5.515 5.94-5.515z"
            fill="#B62993"
            fillRule="nonzero"
          />
          <path
            d="M42.97 54l-7.424-7.424 4.243-4.243 5.728-5.727.424-.424-.424-.425c-2.122-2.121-5.304-1.909-7.213 0l-7.425 7.425c-2.12 2.121-1.909 5.303 0 7.212l8.274 8.274c2.12 2.12 5.303 1.909 7.212 0l2.121-2.122.637-.636-.425-.424-3.181-3.182-.425-.425-.424.425L42.971 54h0z"
            stroke="#FFF"
          />
        </g>
        <g>
          <path
            d="M54.426 43.394l-3.182-3.182 3.182-3.182c1.697-1.697 4.667-1.697 6.364 0l-6.364 6.364z"
            fill="#CC0092"
            fillRule="nonzero"
          />
          <path
            d="M53.79 44.03l.424.425.424-.424 6.364-6.364.637-.637-.425-.424c-2.121-2.121-5.303-1.91-7.212 0l-3.182 3.182-.424.424.424.424 3.182 3.182-.212.213z"
            stroke="#FFF"
          />
          <path
            d="M47.001 44.455l3.182-3.182 3.182 3.182c1.697 1.697 1.697 4.667 0 6.364l-6.364-6.364z"
            fill="#CC0092"
            fillRule="nonzero"
          />
          <path
            d="M46.577 44.03l-.424.425.424.424 6.364 6.364.424.424.425-.424c2.121-2.121 1.909-5.303 0-7.212l-3.182-3.182-.425-.425-.424.425-3.182 3.182z"
            stroke="#FFF"
          />
          <g>
            <path
              d="M45.94 45.515c-1.696 1.697-1.696 4.667 0 6.364l7.425 7.425c1.697 1.697 4.667 1.697 6.364 0l8.273-8.273c1.698-1.697 1.698-4.667 0-6.364l-2.12-2.121-2.97 2.97 2.12 2.12-8.485 8.486-4.667-4.667-5.94-5.94z"
              fill="#00A6BB"
              fillRule="nonzero"
            />
            <path
              d="M63.76 47.637l-7.213 7.212-4.242-4.242-5.728-5.728-.424-.424-.424.424c-2.122 2.121-1.91 5.303 0 7.213l7.424 7.424c2.122 2.121 5.304 1.91 7.213 0l8.273-8.273c2.121-2.121 1.91-5.303 0-7.212l-2.121-2.122-.425-.424-.424.424-3.182 3.182-.636.637.424.424 1.485 1.485z"
              stroke="#FFF"
            />
          </g>
        </g>
        <g>
          <path
            d="M53.365 35.97l-3.182 3.181-3.182-3.182c-1.697-1.697-1.697-4.666 0-6.363l6.364 6.363z"
            fill="#0055A9"
            fillRule="nonzero"
          />
          <path
            d="M54.002 36.606l.424-.424-.424-.425-6.364-6.364-.424-.424-.425.424c-2.121 2.122-1.909 5.304 0 7.213l3.182 3.182.425.424.424-.424 3.182-3.182z"
            stroke="#FFF"
          />
          <path
            d="M54.426 43.394l-3.182-3.182 3.182-3.182c1.697-1.697 4.667-1.697 6.364 0l-6.364 6.364z"
            fill="#00A6BB"
            fillRule="nonzero"
          />
          <path
            d="M53.79 44.03l.424.425.424-.424 6.364-6.364.424-.425-.424-.424c-2.121-2.121-5.303-1.91-7.212 0L50.608 40l-.425.424.425.425 3.182 3.182z"
            stroke="#FFF"
          />
          <g>
            <path
              d="M55.487 44.455c1.697 1.697 4.667 1.697 6.364 0l7.424-7.425c1.697-1.697 1.697-4.667 0-6.364l-8.273-8.273c-1.697-1.697-4.667-1.697-6.364 0l-2.121 2.121 3.182 3.182 2.121-2.121 8.485 8.485-4.879 4.88c-.212-.213-5.94 5.515-5.94 5.515z"
              fill="#FF003B"
              fillRule="nonzero"
            />
            <path
              d="M57.608 26.636l7.425 7.424-4.243 4.243-5.728 5.728-.636.636.424.424c2.122 2.121 5.304 1.91 7.213 0l7.424-7.424c2.122-2.122 1.91-5.304 0-7.213l-8.273-8.273c-2.121-2.121-5.303-1.91-7.212 0l-2.122 2.121-.424.424.424.425 3.182 3.182.425.424.424-.424 1.697-1.697z"
              stroke="#FFF"
            />
          </g>
        </g>
        <g>
          <path
            d="M46.153 37.242l3.182 3.182-3.182 3.182c-1.697 1.697-4.667 1.697-6.364 0l6.364-6.364z"
            fill="#0055A9"
            fillRule="nonzero"
          />
          <path
            d="M46.577 36.818l-.424-.424-.424.424-6.364 6.364-.425.424.425.425c2.121 2.12 5.303 1.909 7.212 0l3.182-3.182.424-.425L49.76 40l-3.182-3.182z"
            stroke="#FFF"
          />
          <path
            d="M53.365 35.97l-3.182 3.181-2.97-2.97c-1.696-1.696-1.696-4.666 0-6.363l6.152 6.151z"
            fill="#FF003B"
            fillRule="nonzero"
          />
          <path
            d="M54.002 36.606l.424-.424-.424-.425-6.364-6.364-.424-.424-.425.424c-2.121 2.122-1.909 5.304 0 7.213l3.182 3.182.425.424.424-.424 3.182-3.182z"
            stroke="#FFF"
          />
          <g>
            <path
              d="M54.426 34.909c1.697-1.697 1.697-4.667 0-6.364l-7.425-7.425c-1.697-1.697-4.666-1.697-6.364 0l-8.273 8.273c-1.697 1.697-1.697 4.667 0 6.364l2.122 2.122 3.182-3.182-2.122-2.122 8.486-8.485 4.666 4.667c0 .424 5.728 6.152 5.728 6.152z"
              fill="#0055A9"
              fillRule="nonzero"
            />
            <path
              d="M36.607 32.788l7.212-7.213 4.243 4.243 5.728 5.727.424.424.424-.424c2.122-2.121 1.91-5.303 0-7.212l-7.424-7.425c-2.122-2.121-5.304-1.91-7.213 0l-8.273 8.273c-2.121 2.122-1.91 5.304 0 7.213l2.121 2.121.425.424.424-.424 3.182-3.182.424-.424-.424-.424L36.395 33l.212-.212z"
              stroke="#FFF"
            />
          </g>
        </g>
        <path
          d="M34.804 76.374h2.09v15.708h-2.09V76.374zm5.61 0h10.318v1.76h-8.228v4.994h7.216v1.76h-7.216v7.194h-2.09V76.374zm23.672 4.73c-.235-1.115-.752-1.95-1.551-2.508-.8-.557-1.749-.836-2.849-.836-.939 0-1.742.176-2.409.528a4.754 4.754 0 00-1.65 1.419 6.125 6.125 0 00-.957 2.035 9.1 9.1 0 00-.308 2.376c0 .895.103 1.742.308 2.541.205.8.524 1.496.957 2.09a4.726 4.726 0 001.661 1.419c.675.352 1.481.528 2.42.528.69 0 1.302-.114 1.837-.341a4.158 4.158 0 001.386-.946c.389-.403.693-.884.913-1.441.22-.557.352-1.159.396-1.804h2.09c-.205 1.98-.887 3.52-2.046 4.62-1.159 1.1-2.743 1.65-4.752 1.65-1.217 0-2.28-.209-3.19-.627a6.265 6.265 0 01-2.266-1.727c-.601-.733-1.052-1.599-1.353-2.596-.3-.997-.451-2.068-.451-3.212 0-1.144.161-2.218.484-3.223.323-1.005.796-1.881 1.419-2.629a6.615 6.615 0 012.332-1.771c.931-.433 1.998-.649 3.201-.649.821 0 1.599.11 2.332.33.733.22 1.386.543 1.958.968a5.44 5.44 0 011.43 1.595c.381.638.63 1.375.748 2.211h-2.09z"
          fill="#FFF"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
});
export default SvgIfcThumbnail;
SvgIfcThumbnail.iconName = 'ifc-thumbnail';
SvgIfcThumbnail.displayName = 'SvgIfcThumbnail';
